<template>
    
	<v-container fluid>
        
        <v-layout row wrap>
            <v-flex xs6>
                <v-card dark color="primary" class="mx-4">
                    <v-tabs fixed centered>
                        <v-tabs-bar class="cyan" dark>
                            <v-tabs-slider class="yellow"></v-tabs-slider>
                            <v-tabs-item v-for="i in tabitems" :key="i.id" :href="'#tab-' + i.id">
                                {{ i.name }}
                            </v-tabs-item>
                        </v-tabs-bar>
                        <v-tabs-items>
                            <v-tabs-content v-for="i in tabitems" :key="i.id" :id="'tab-' + i.id">
                                <draggable id="list_1" class="dragArea" v-model="tspo[i.id]" :options="{group:'screens'}" @end="onEnd">
                                        <div class="drag-cursor" v-for="j in tspo[i.id]" :key="j.key">
                                            {{j.title}}
                                        </div>
                                </draggable>
                            </v-tabs-content>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-flex>
            <v-flex xs3>
                <v-card dark color="secondary" class="mx-4">
                    <v-card-text class="text-xs-center px-0">Screen 1
                        <br/><small>Ancient Waterfall</small></v-card-text>
                    <v-btn flat icon color="blue lighten-2" style="position:absolute;top:0;right:0;">
                        <v-icon>insert_link</v-icon>
                    </v-btn>
                    <draggable id="screen_1" v-model="list" class="dragArea" :options="{group:'screens'}" @end="onEnd">
                        
                            <div class="drag-cursor" v-for="element in list" :key="element.id">{{element.title}}</div>
                        
                    </draggable>
                    <!-- <v-btn raised color="primary"><v-icon>tv</v-icon>Preview</v-btn> -->
                </v-card>
            </v-flex>
            <v-flex xs3>
                <v-card dark color="secondary" class="mx-4">
                    <v-card-text class="text-xs-center px-0">Screen 2
                        <br/><small>Autumn Rain</small></v-card-text>
                    <v-btn flat icon color="blue lighten-2" style="position:absolute;top:0;right:0;">
                        <v-icon>insert_link</v-icon>
                    </v-btn>
                    <draggable id="screen_2" v-model="list_b" class="dragArea" :options="{group:'screens'}" @end="onEnd">
                        
                             <div class="drag-cursor" v-for="element in list_b" :key="element.id">{{element.title}}</div>
                        
                    </draggable>
                    <!-- <v-btn raised color="primary"><v-icon>tv</v-icon>Preview</v-btn> -->
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    
</template>
<style>
	.dragArea {
	  min-height: 10px;
	}
    .drag-cursor {
        cursor: grab;
        padding: 6px 0;
        margin: 2px 0;
    }
</style>
<script>
	import draggable from 'vuedraggable'
    import firebase from 'firebase'
    import axios from 'axios';

    const eventsJSON = "https://tauchschule-poseidon.ch/wp-json/wp/v2/events"
    const kurseJSON = "https://tauchschule-poseidon.ch/wp-json/wp/v2/kurse"
    const kursdatenJSON = "https://tauchschule-poseidon.ch/wp-json/wp/v2/kursdaten"
    const reisenJSON = "https://tauchschule-poseidon.ch/wp-json/wp/v2/reisen"

    var WooCommerceAPI = require('woocommerce-api');
 
    var WooCommerce = new WooCommerceAPI({
      url: 'https://tauchbar.ch',
      consumerKey: 'ck_1bea11a2c4913fd030945ab00a7833f6ffd574e4',
      consumerSecret: 'cs_b273a101df64b555cb89cd0738bffb604ded221f',
      wpAPI: true,
      version: 'wc/v1'
    });

    import Vue from 'vue'

	export default {
	  name: 'Dashboard',
	  components: {
		draggable,
	  },
	  data () {
	    return {
            tabitems: [{name: 'kurse', id: 0, slug:"tspo.courses"}, {name: 'reisen', id: 1, slug:"tspo.reisen"}, {name: 'events', id: 2, slug:"tspo.events"}, {name: 'produkte', id: 3, slug:"tspo.products"}],
            tabContent: [],
	    	list: [],
            list_b: [],
	    	screen_1_values: [],
	    	screen_2_values: [],
            tspo: []
	    }
	  },      
      methods: {
        snapshotToArray: function(snapshot) {
            var returnArr = [];
            snapshot.forEach(function(childSnapshot) {
                var item = childSnapshot.val();
                item.key = childSnapshot.key;
                returnArr.push(item);
            });
            return returnArr;
        },
        jsonToArray: function(data, type) {
            var returnJSonArray = [];
            data.forEach(function(dataChild){
                var item = dataChild;
                item.title = dataChild.title.rendered;
                item.id = dataChild.id;
                item.key = dataChild.id;
                item.type = type;
                returnJSonArray.push(item);
                
            });
            return returnJSonArray;
        },

        productToArray: function(data) {
            var returnJSonArray = [];
            data.forEach(function(dataChild){
                console.log(dataChild)

                var item = dataChild;
                item.title = dataChild.name;
                item.price = dataChild.price_html;
                item.onSale = dataChild.name;
                item.image = dataChild.images[0].src;
                item.id = dataChild.id;
                item.key = dataChild.id;
                item.type = "product";
                returnJSonArray.push(item);
                
            });

            return returnJSonArray;
        },

        onMoveCallback: function(evt, originalEvent){
           console.log(evt, originalEvent);
            // return false; — for cancel
        },

        saveDataBackToFirebase: function(){
            console.log("save");
            firebase.database().ref('screen_1/').set(
                this.list    
            );
            firebase.database().ref('screen_2/').set(
                this.list_b    
            );
        },

        onEnd: function(index, element){
            this.saveDataBackToFirebase();
        }

      },
	  mounted (){
        var that = this;
	  	console.log("init")
        //GET FIREBASE DATA SCREEN - 1
        var screen_1_fb_data = firebase.database().ref('/screen_1/').once('value').then((snapshot) => {
            this.list = this.snapshotToArray(snapshot);
            console.log("got screen 1")
        });

        //GET FIREBASE DATA SCREEN - 2
        var screen_2_fb_data = firebase.database().ref('/screen_2/').once('value').then((snapshot) => {
            this.list_b = this.snapshotToArray(snapshot);
            console.log("got screen 2")
        });

        //GET COURSES
        var kursData = axios.get(kurseJSON)
            .then(response => {
              Vue.set(this.tspo, 0, this.jsonToArray(response.data, 'kurse'))
            }).catch(e => {
              console.log(e)
            });

        //GET REISEN
        var reisenData = axios.get(reisenJSON)
            .then(response => {
              Vue.set(this.tspo, 1, this.jsonToArray(response.data, 'reisen'))
            }).catch(e => {
              console.log(e)
            });

        //GET EVENTS
        var eventData = axios.get(eventsJSON)
            .then(response => {
              Vue.set(this.tspo, 2, this.jsonToArray(response.data, 'events'))
            }).catch(e => {
              console.log(e)
            });

        WooCommerce.get('products?category=968', function(err, data, res){
            Vue.set(that.tspo, 3, that.productToArray(JSON.parse(res) ))
        });
	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue